<mat-toolbar id="toolbar" class="mat-elevation-z2">
    <button
            *ngIf="hasUser()"
            mat-icon-button
            (click)="sidebarShow(!navigationExpanded$)">
        <mat-icon>menu</mat-icon>
    </button>

    <div class="title" (click)="debugMode()">
        Hort360 Manager {{ debugClicked > 5 ? debugClicked : '' }}
    </div>

    <span class="fill-remaining-space"></span>

    <button mat-button routerLink="/home" *ngIf="hasUser()">
        Home
    </button>

    <button mat-button routerLink="/reports" *ngIf="hasUser()">
        Reports
    </button>

    <a mat-button [href]="dataService.loginToHort360Link()" target="_blank">
        Launch Hort360
    </a>

    <button *ngIf="hasUser()"
            mat-icon-button
            (click)="shouldLogoutUser()">
        <mat-icon>logout</mat-icon>
    </button>

    <rs-loading-http class="loading-bar"></rs-loading-http>

</mat-toolbar>

<mat-sidenav-container hasBackdrop="false" class="sidenav-container" id="scrollParent" autosize style="overflow-y: auto !important;">

    <!-- Side-by-side nav -->
    <mat-sidenav
            *ngIf="hasUser()"
            [mode]="'side'"
            #sidenav
            class="sidenav"
            mode="side"
            [class.opened]="navigationExpanded$"
            [opened]="navigationVisible$">
        <mat-nav-list>
            <div class="sidenavsection">
                <a (click)="shouldLogoutUser()" mat-list-item>
                    <mat-icon matListItemAvatar color="accent">account_circle</mat-icon>
                    <p matListItemTitle style="max-width: 15vw;"
                       [@menuItemAnimation]="navigationExpanded$"
                       (@menuItemAnimation.start)="startAnimation()" (@menuItemAnimation.done)="doneAnimation()"
                    >User: {{( userService.activeUserClaims?.username || 'Unknown')}}</p>
                </a>

                <mat-divider></mat-divider>
            </div>

            <div class="sidenavsection" *ngFor="let link of sideLinks$">
                <a
                    mat-list-item
                    [routerLink]="link.path"
                    routerLinkActive="activated"
                    [@padSubLevel]="navigationExpanded$"
                >
                    <mat-icon matListItemAvatar>{{link.icon}}</mat-icon>
                    <p matListItemTitle
                       [@menuItemAnimation]="navigationExpanded$"
                       (@menuItemAnimation.start)="startAnimation()" (@menuItemAnimation.done)="doneAnimation()"
                    >{{link.name}}</p>
                </a>

                <mat-divider></mat-divider>
            </div>

            <div class="sidenavsection">
                <a
                        mat-list-item
                        (click)="shouldLogoutUser()"
                        routerLinkActive="activated"
                        [@padSubLevel]="navigationExpanded$"
                >
                    <mat-icon matListItemAvatar>logout</mat-icon>
                    <p matListItemTitle
                       [@menuItemAnimation]="navigationExpanded$"
                       (@menuItemAnimation.start)="startAnimation()" (@menuItemAnimation.done)="doneAnimation()"
                    >Logout</p>
                </a>

                <mat-divider></mat-divider>
            </div>

            <!-- Open / Close handle -->
            <a mat-list-item (click)="sidebarShow(!navigationExpanded$)">
                <p matListItemTitle style="text-align: right;">
                    <mat-icon *ngIf="!navigationExpanded$">chevron_right</mat-icon>
                    <mat-icon *ngIf="navigationExpanded$">chevron_left</mat-icon>
                </p>
            </a>

        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
        <!-- Page Content -->
        <div id="content">
            <router-outlet (activate)="onActivate($event, outlet)" #outlet></router-outlet>
        </div>

        <!-- Footer -->
        <footer class="docs-footer">
            <div class="docs-footer-list">
                <div class="docs-footer-list-item">
                    &copy; <a href="http://www.growcom.com.au/" target="_blank">Growcom {{thisYear$}}</a>, All Rights Reserved
                </div>
                <div class="docs-footer-list-item">
                  •&nbsp;<a href="http://www.growcom.com.au/about-us/" target="_blank">Privacy</a>&nbsp;•&nbsp;<i>{{ version$ }}</i>
                </div>
            </div>
        </footer>
    </mat-sidenav-content>
</mat-sidenav-container>


